import { listModelManager } from '@/utils/http'
import { mapSiteMedia, unwrapRows } from '@/utils/content'
import { resolveMediaUrl, isMissingOrFallbackImage } from '@/utils/media'

/** Empty until CMS upload (model_manager type=11 / 12) */
export const PRODUCT_SECTION_BG_FALLBACK = ''
export const SOLUTIONS_SECTION_BG_FALLBACK = ''

let mediaCache = null
let mediaLoading = null

function staticMedia() {
  return {
    pageBanners: {},
    oneStop: { video: '', poster: '' },
    productSectionBg: PRODUCT_SECTION_BG_FALLBACK,
    solutionsSectionBg: SOLUTIONS_SECTION_BG_FALLBACK
  }
}

export function resetSiteMediaCache() {
  mediaCache = null
  mediaLoading = null
}

export async function fetchSiteMedia(force = false, locale) {
  if (!force && mediaCache) return mediaCache
  if (!force && mediaLoading) return mediaLoading

  mediaLoading = (async () => {
    try {
      const res = await listModelManager({ status: 1, pageNum: 1, pageSize: 50 }, locale)
      const mapped = mapSiteMedia(unwrapRows(res))
      const fallback = staticMedia()
      mediaCache = {
        pageBanners: { ...fallback.pageBanners, ...mapped.pageBanners },
        oneStop: {
          video: mapped.oneStop.video || fallback.oneStop.video,
          poster: mapped.oneStop.poster || ''
        },
        productSectionBg: mapped.productSectionBg || fallback.productSectionBg,
        solutionsSectionBg: mapped.solutionsSectionBg || fallback.solutionsSectionBg
      }
      return mediaCache
    } catch (e) {
      mediaCache = staticMedia()
      return mediaCache
    } finally {
      mediaLoading = null
    }
  })()

  return mediaLoading
}

export function getPageBanner(key, media) {
  const source = media || mediaCache || staticMedia()
  const raw = (source.pageBanners && source.pageBanners[key]) || ''
  if (!raw) return ''
  const resolved = resolveMediaUrl(raw)
  if (!resolved || isMissingOrFallbackImage(resolved)) return ''
  return resolved
}

export function getProductSectionBg(media) {
  const source = media || mediaCache || staticMedia()
  const raw = source.productSectionBg || ''
  if (!raw) return ''
  const resolved = resolveMediaUrl(raw)
  if (!resolved || isMissingOrFallbackImage(resolved)) return ''
  return resolved
}

export function getSolutionsSectionBg(media) {
  const source = media || mediaCache || staticMedia()
  const raw = source.solutionsSectionBg || ''
  if (!raw) return ''
  const resolved = resolveMediaUrl(raw)
  if (!resolved || isMissingOrFallbackImage(resolved)) return ''
  return resolved
}
